<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Nota Tertunda</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-print" aria-hidden="true"></i> Print
                          </button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 100px">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#piutang" data-toggle="tab" aria-expanded="false" class="nav-link active">Piutang</a></li>
                            <li class="nav-item"><a href="#piutang-raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="piutang">
                                <div class="table-responsive">
                                    <h5><b>Laporan Nota Tertunda ≥ 68 hari</b></h5>
                                    <span><i>Pada tgl {{ date | dateFormat('dd, DD/MM/YYYY') }}</i></span>
                                    <hr>
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>No</th>
                                            <th>Sale No</th>
                                            <th>Date</th>
                                            <th>Customer</th>
                                            <th>Area</th>
                                            <th>Salesman</th>
                                            <th class="text-right">Retur</th>
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Payment</th>
                                            <th class="text-right">Outstanding</th>
                                            <th>Jatuh Tempo</th>
                                            <th class="text-center">Tempo</th>
                                            <th>Keterangan</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in dataMore68" :key="d.id">
                                                <td>{{ d.no }}</td>
                                                <td>
                                                  <span class="text-ref-sales" @click="showSaleNo(d.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                                    {{ d.sale_no }}
                                                  </span>
                                                </td>
                                                <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>
                                                  {{ d.customer }} <span v-show="d.payment_method === 'Giro'" class="badge badge-info">{{ d.payment_method }}</span>
                                                </td>
                                                <td>{{ d.area }}</td>
                                                <td>{{ d.salesman }}</td>
                                                <td class="text-right">{{ d.retur | currency }}</td>
                                                <td class="text-right">{{ d.total | currency }}</td>
                                                <td class="text-right">{{ d.payment_balance | currency }}</td>
                                                <td class="text-right">{{ d.outstanding | currency }}</td>
                                                <td>{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td class="text-center">{{ d.age | currency }}</td>
                                                <td>{{ d.notes }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                              <td colspan="12" class="text-right"><i>Total Retur ≥ 68</i></td>
                                              <td class="text-right"><b>{{ totalReturDataMore68 | currency }}</b></td>
                                            </tr>
                                            <tr>
                                              <td colspan="12" class="text-right"><i>Total Penjualan ≥ 68</i></td>
                                              <td class="text-right"><b>{{ totalDataMore68 | currency }}</b></td>
                                            </tr>
                                            <tr>
                                              <td colspan="12" class="text-right"><i>Total Pembayaran ≥ 68</i></td>
                                              <td class="text-right"><b>{{ totalPaymentDataMore68 | currency }}</b></td>
                                            </tr>
                                            <tr>
                                              <td colspan="12" class="text-right"><i>Total Piutang ≥ 68</i></td>
                                              <td class="text-right"><b>{{ totalOutstandingDataMore68 | currency }}</b></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div class="table-responsive mt-5">
                                    <h5><b>Laporan Nota Tertunda ≥ 60 &lt; 68 hari</b></h5>
                                    <span><i>Pada tgl {{ date | dateFormat('DD/MM/YYYY') }}</i></span>
                                    <hr>
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                          <th>No</th>
                                          <th>Sale No</th>
                                          <th>Date</th>
                                          <th>Customer</th>
                                          <th>Area</th>
                                          <th>Salesman</th>
                                          <th class="text-right">Retur</th>
                                          <th class="text-right">Total</th>
                                          <th class="text-right">Payment</th>
                                          <th class="text-right">Outstanding</th>
                                          <th>Jatuh Tempo</th>
                                          <th class="text-center">Tempo</th>
                                          <th>Keterangan</th>
                                        </thead>
                                        <tbody>
                                          <tr v-for="d in dataMore6068" :key="d.id">
                                              <td>{{ d.no }}</td>
                                              <td>
                                                <span class="text-ref-sales" @click="showSaleNo(d.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ d.sale_no }}</span>
                                              </td>
                                              <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td>
                                                {{ d.customer }} <span v-show="d.payment_method === 'Giro'" class="badge badge-info">{{ d.payment_method }}</span>
                                              </td>
                                              <td>{{ d.area }}</td>
                                              <td>{{ d.salesman }}</td>
                                              <td class="text-right">{{ d.retur | currency }}</td>
                                              <td class="text-right">{{ d.total | currency }}</td>
                                              <td class="text-right">{{ d.payment_balance | currency }}</td>
                                              <td class="text-right">{{ d.outstanding | currency }}</td>
                                              <td>{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                              <td class="text-center">{{ d.age | currency }}</td>
                                              <td>{{ d.notes }}</td>
                                          </tr>
                                        </tbody>
                                        <tfoot>
                                          <tr>
                                              <td colspan="12" class="text-right"><i>Total Retur ≥ 60 &lt; 68</i></td>
                                              <td class="text-right"><b>{{ totalReturDataMore6068 | currency }}</b></td>
                                          </tr>
                                          <tr>
                                              <td colspan="12" class="text-right"><i>Total Penjualan ≥ 60 &lt; 68</i></td>
                                              <td class="text-right"><b>{{ totalDataMore6068 | currency }}</b></td>
                                          </tr>
                                          <tr>
                                              <td colspan="12" class="text-right"><i>Total Pembayaran ≥ 60 &lt; 68</i></td>
                                              <td class="text-right"><b>{{ totalPaymentDataMore6068 | currency }}</b></td>
                                          </tr>
                                          <tr>
                                              <td colspan="12" class="text-right"><i>Total Piutang ≥ 60 &lt; 68</i></td>
                                              <td class="text-right"><b>{{ totalOutstandingDataMore6068 | currency }}</b></td>
                                          </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane" id="piutang-raw">
                                <div class="table-responsive">
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                        <thead>
                                            <th>No</th>
                                            <th>Sale No</th>
                                            <th>Date</th>
                                            <th>Customer</th>
                                            <th>Area</th>
                                            <th>Salesman</th>
                                            <th class="text-right">Retur</th>
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Payment</th>
                                            <th class="text-right">Outstanding</th>
                                            <th class="text-center">Jatuh Tempo</th>
                                            <th>Tempo</th>
                                            <th>Keterangan</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="d in dataRaw" :key="d.id">
                                                <td>{{ d.no }}</td>
                                                <td>
                                                  <span class="text-ref-sales" @click="showSaleNo(d.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ d.sale_no }}</span>
                                                </td>
                                                <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td>
                                                  {{ d.customer }} <span v-show="d.payment_method === 'Giro'" class="badge badge-info">{{ d.payment_method }}</span>
                                                </td>
                                                <td>{{ d.area }}</td>
                                                <td>{{ d.salesman }}</td>
                                                <td class="text-right">{{ d.retur | currency }}</td>
                                                <td class="text-right">{{ d.total | currency }}</td>
                                                <td class="text-right">{{ d.payment_balance | currency }}</td>
                                                <td class="text-right">{{ d.outstanding | currency }}</td>
                                                <td>{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                                <td class="text-center">{{ d.age | currency }}</td>
                                                <td>{{ d.notes }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getHeader, sale2Url, salesUrl } from '../../config'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'PiutangOverdue',
  props: ['scroll'],
  components: {
    Loading,
    SaleModal
  },
  data () {
    return {
      date: new Date().toISOString(),
      loadingSales: true,
      selected: [],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    dataMore68 () {
      var loop = []
      var array = this.dataRaw.filter(d => d.outstanding > 0)
      var no = 0
      for (let i = 0; i < array.length; i++) {
        no += 1
        if (parseFloat(array[i].age) >= 68) {
          var obj = {
            no: no,
            id: array[i].id,
            sale_no: array[i].sale_no,
            sale_date: array[i].sale_date,
            sale_due_date: array[i].sale_due_date,
            age: array[i].age,
            customer: array[i].customer,
            customer_no: array[i].customer_no,
            area: array[i].area,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            subtotal: array[i].subtotal,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            discount: array[i].discount,
            total: array[i].total,
            retur: array[i].retur,
            outstanding: array[i].outstanding,
            notes: array[i].notes,
            payment_balance: array[i].payment_balance,
            payment_method: array[i].payment_method
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalDataMore68 () {
      var sum = 0
      var array = this.dataMore68
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPaymentDataMore68 () {
      var sum = 0
      var array = this.dataMore68
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].payment_balance)
      }
      return sum
    },
    totalReturDataMore68 () {
      var sum = 0
      var array = this.dataMore68
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].retur)
      }
      return sum
    },
    totalOutstandingDataMore68 () {
      var sum = 0
      var array = this.dataMore68
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    dataMore6068 () {
      var loop = []
      var array = this.dataRaw.filter(d => d.outstanding > 0)
      var no = 0
      for (let i = 0; i < array.length; i++) {
        no += 1
        if (parseFloat(array[i].age) >= 60 && parseFloat(array[i].age) < 68) {
          var obj = {
            no: no,
            id: array[i].id,
            sale_no: array[i].sale_no,
            sale_date: array[i].sale_date,
            sale_due_date: array[i].sale_due_date,
            age: array[i].age,
            customer: array[i].customer,
            customer_no: array[i].customer_no,
            area: array[i].area,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            subtotal: array[i].subtotal,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            discount: array[i].discount,
            total: array[i].total,
            retur: array[i].retur,
            outstanding: array[i].outstanding,
            notes: array[i].notes,
            payment_balance: array[i].payment_balance,
            payment_method: array[i].payment_method
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalDataMore6068 () {
      var sum = 0
      var array = this.dataMore6068
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPaymentDataMore6068 () {
      var sum = 0
      var array = this.dataMore6068
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].payment_balance)
      }
      return sum
    },
    totalReturDataMore6068 () {
      var sum = 0
      var array = this.dataMore6068
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].retur)
      }
      return sum
    },
    totalOutstandingDataMore6068 () {
      var sum = 0
      var array = this.dataMore6068
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].outstanding)
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async showPaymentNo (id) {
      var payload = {
        id: id
      }
      this.$store.dispatch('getPaymentShow', payload)
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      var obj = {
        date: this.date,
        company_no: this.company_no
      }
      var url = salesUrl + '/piutang-overdue'
      console.log(url)
      await axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: [
          {
            id: 68,
            date: this.date,
            title: 'Laporan Nota Tertunda >= 68 hari',
            total_sales: this.totalDataMore68,
            total_payment: this.totalPaymentDataMore68,
            total_outstanding: this.totalOutstandingDataMore68,
            data: this.dataMore68
          },
          {
            id: 6068,
            date: this.date,
            title: 'Laporan Nota Tertunda >= 60 68 hari',
            total_sales: this.totalDataMore6068,
            total_payment: this.totalPaymentDataMore6068,
            total_outstanding: this.totalOutstandingDataMore6068,
            data: this.dataMore6068
          }
        ]
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(sale2Url + '/piutang-overdue', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
